module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0026.dd1cba02.jpg";